import React, {forwardRef} from 'react';
import PropTypes from 'prop-types';
import MuiAlert from '@mui/material/Alert';

const Alert = forwardRef(({
    children,
    className,
    icon,
    onClose,
    variant,
    severity,
    hidden,
}, ref) => {
    const resolvedSeverity = ['error', 'info', 'success', 'warning'].includes(severity) ? severity : 'default';

    return (
        <MuiAlert
            ref={ref}
            variant={variant}
            className={className}
            icon={icon}
            onClose={onClose}
            severity={resolvedSeverity}
            hidden={hidden}
        >
            {children}
        </MuiAlert>
    );
});

Alert.displayName = 'Alert';

Alert.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    icon: PropTypes.oneOfType([
        PropTypes.bool,
        PropTypes.node,
    ]),
    onClose: PropTypes.func,
    variant: PropTypes.string,
    severity: PropTypes.oneOf(['error', 'info', 'success', 'warning']),
    hidden: PropTypes.bool,
};

export default Alert;
